import React, { useCallback, useEffect, useState } from 'react';
import { apiRequest } from '../../utils/apiUtils';
import './ValidateMatchButton.css';

interface Props { matchId: string }

const ValidateMatchButton: React.FC<Props> = ({ matchId }) => {
  const [code, setCode] = useState<string | null>(null);
  const [expiresAt, setExpiresAt] = useState<number | null>(null);
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generate = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await apiRequest<{ code: string; expiresAt: string }>(
      `/api/matches/${matchId}/check-in-code`, { method: 'POST', body: {} }
    );
    setLoading(false);
    if (res.error || !res.data) { setError(res.error || 'No pudimos generar el código'); return; }
    setCode(res.data.code);
    setExpiresAt(new Date(res.data.expiresAt).getTime());
  }, [matchId]);

  useEffect(() => {
    if (!expiresAt) return;
    const tick = () => {
      const left = Math.max(0, Math.round((expiresAt - Date.now()) / 1000));
      setSecondsLeft(left);
      // Mostrar un código vencido es peor que no mostrar ninguno.
      if (left === 0) { setCode(null); setExpiresAt(null); }
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [expiresAt]);

  if (!code) {
    return (
      <div className="validate-match">
        <button className="validate-match-cta" onClick={generate} disabled={loading}>
          {loading ? 'Generando...' : 'Validar partido'}
        </button>
        {error && <p className="validate-match-error">{error}</p>}
      </div>
    );
  }

  return (
    <div className="validate-match validate-match-open">
      <p className="validate-match-lead">Muéstralo en el mostrador</p>
      {/* En web no dibujamos el QR: quien organiza desde la computadora no la
          lleva al mostrador. El código se lee o se tipea. */}
      <strong className="validate-match-code">{code}</strong>
      <p className="validate-match-hint">Vence en {secondsLeft} s</p>
    </div>
  );
};

export default ValidateMatchButton;
